{
  "name": "workards-ng-web",
  "version": "1.0.18-pre43",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:dev-ngsw": "ng build --configuration development-ngsw",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "prettier:check": "prettier --check .",
    "prettier:write": "prettier --write .",
    "i18n": "ng extract-i18n --output-path src/i18n"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.23",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.23",
    "@angular/compiler": "^21.2.23",
    "@angular/core": "^21.2.23",
    "@angular/forms": "^21.2.23",
    "@angular/google-maps": "^21.2.14",
    "@angular/localize": "^21.2.23",
    "@angular/material": "^21.2.14",
    "@angular/material-date-fns-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.23",
    "@angular/platform-browser-dynamic": "^21.2.23",
    "@angular/router": "^21.2.23",
    "@angular/service-worker": "^21.2.23",
    "@azure/msal-browser": "^5.22.0",
    "@qarepa/common": "file:qarepa-common-21.1.0-pre03.tgz",
    "@qarepa/schematics": "file:qarepa-schematics-21.0.0-pre02.tgz",
    "@tinymce/tinymce-angular": "^7.0.0",
    "chart.js": "^4.4.3",
    "chartjs-plugin-datalabels": "^2.2.0",
    "date-fns": "^2.30.0",
    "lottie-web": "^5.9.2",
    "ng-recaptcha-2": "^21.0.1",
    "rxjs": "~7.8.2",
    "tinymce": "^6.3.1",
    "tslib": "^2.6.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.24",
    "@angular/cli": "^21.2.24",
    "@angular/compiler-cli": "^21.2.23",
    "@types/chart.js": "^2.9.41",
    "@types/google.maps": "3.55.2",
    "@types/jasmine": "~3.8.0",
    "@types/node": "^12.11.1",
    "angular-eslint": "^21.4.0",
    "autoprefixer": "^10.4.20",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "jasmine-core": "~3.8.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "postcss": "^8.4.41",
    "prettier": "^3.3.3",
    "prettier-eslint": "^15.0.1",
    "prettier-plugin-tailwindcss": "^0.6.5",
    "tailwindcss": "^3.4.7",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.70.0",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
